/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA
 */
import { ltiClaims } from '@/core/utils/consts';
import { get } from 'svelte/store';
import { decodedAccessToken } from '@/store/accessToken';

/**
 * Tells if should show 'IP address' column in the current session
 * @returns {Boolean}
 */
export function getShowIPAddress() {
    const accessToken = get(decodedAccessToken);
    return Boolean(
        accessToken[ltiClaims.custom] &&
            accessToken[ltiClaims.custom].extraColumns &&
            Array.isArray(accessToken[ltiClaims.custom].extraColumns) &&
            accessToken[ltiClaims.custom].extraColumns.includes('ip')
    );
}

/**
 * Tells if should hide header (of Monitoring view)
 * @returns {Boolean}
 */
export function getHideHeader() {
    const accessToken = get(decodedAccessToken);
    return Boolean(
        accessToken[ltiClaims.custom]
            && accessToken[ltiClaims.custom].hideHeader
            && accessToken[ltiClaims.custom].hideHeader !== 'false'
    );
}
